import { c as _c } from "react/compiler-runtime";
import { CardContentBadge, FlexCenter, TextBody } from "@opensea/ui-kit";
import { Add, CheckCircleFilled } from "@opensea/ui-kit/icons";
export function SelectItemBadge(t0) {
  const $ = _c(8);
  const {
    active,
    selectedIndex,
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick) {
    t1 = event => {
      event.preventDefault();
      event.stopPropagation();
      onClick?.(event);
    };
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== active || $[3] !== selectedIndex) {
    t2 = active ? selectedIndex ? <FlexCenter className="size-8 justify-center rounded-full bg-blue-3"><TextBody color="white" size="sm" weight="semibold">{selectedIndex}</TextBody></FlexCenter> : <CheckCircleFilled className="fade-in m-[-3px] animate-in" fill="blue-3" size={38} /> : <Add className="fade-in animate-in rounded-full bg-black/80" color="white" size={32} />;
    $[2] = active;
    $[3] = selectedIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <CardContentBadge><button className="-right-2 -top-2 absolute flex size-20 justify-end pt-2 pr-2 focus-visible:outline-hidden" onClick={t1} type="button">{t2}</button></CardContentBadge>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}